import { useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { selectCookieDomain, selectIsHttps } from 'core/selectors/env';
import { BONUS_BUTTON_POPUP_WAS_SHOWN } from 'core/modules/BonusButton/utils/keys';

export const useHandlePopupCookie = (isQualified) => {
  const cookieDomain = useSelector(selectCookieDomain);
  const isHttps = useSelector(selectIsHttps);

  const cookieValue = useMemo(() => JSON.parse(Cookies.get(BONUS_BUTTON_POPUP_WAS_SHOWN) || '{}'), []);

  useEffect(() => {
    const updatedCookie = {
      ...cookieValue,
      [isQualified ? 'postInstallPopupWasShown' : 'preInstallPopupWasShown']: true,
    };

    if (cookieDomain && isHttps) {
      Cookies.set(BONUS_BUTTON_POPUP_WAS_SHOWN, JSON.stringify(updatedCookie), {
        path: '/',
        domain: cookieDomain,
        secure: isHttps,
      });
    }
  }, [cookieDomain, isHttps]);

  return cookieValue;
};
